export const ROLES = {
    COMPLIANCE_OFFICER: "ComplianceOfficer",
    RECOMMENDATION_COMMUNICATOR: "RecommendationCommunicator"
};



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/authenticationConstants.js
 **/